import { PathKeys } from "types";

export const PATHS: { [key in PathKeys]: string } = {
    SEARCH: "/",
    RESULTS: "/images",
    NOPAGE: "*",
};

export default PATHS;
